<template>
  <v-container grid-list-md>
    <h1>{{ $store.getters.sourceDictionaryName }} / Alphabet ({{ letters.length }})</h1>
    <v-layout row wrap>
      <v-flex lg3 xs6 md5>
        <AlphabetImage></AlphabetImage>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs4 sm2>
        <v-btn
                v-on:click="create"
        >
          <v-icon>add</v-icon>
          Add letter
        </v-btn>
      </v-flex>
    </v-layout>

    <LettersList :letters="letters" v-on:change="edit"></LettersList>

    <LetterDialog v-model="dialog" :model="model"></LetterDialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import debounce from 'lodash/debounce'
import { FETCH_ALPHABET } from '../store/action-types'
import LettersList from '../components/LettersList'
import LetterDialog from '../components/LetterDialog'
import AlphabetImage from '../components/AlphabetImage'

export default {
  components: { AlphabetImage, LetterDialog, LettersList },
  data () {
    return {
      dialog: false,
      model: null
    }
  },
  computed: {
    ...mapState([
      'letters',
      'sourceDictionary'
    ])
  },
  created () {
    this.debouncedfetchList = debounce(this.fetchList, 100)
    this.debouncedfetchList()
  },
  watch: {
    sourceDictionary () {
      if (this.sourceDictionary) {
        this.debouncedfetchList()
      }
    }
  },
  methods: {
    edit (model) {
      this.model = model
      this.dialog = true
    },
    async fetchList () {
      await this.$store.dispatch(FETCH_ALPHABET)
    },
    create () {
      this.model = null
      this.dialog = true
    }
  }
}
</script>
